(function () {
  if (customElements.get('tangle-tap-game')) return;

  var STORE_KEY = 'naturall-tangle-tap-best';
  var INK = '#173F2D';
  var BG = '#B9B0CF';
  var SIZE = 400;
  var CX = 200;
  var CY = 238;
  var FACE_R = 62;
  var LIVES = 3;
  var HAIR = '#9A4A1E';
  var SWEATER = '#2F5B3A';
  // Part of the character picture that holds the face, as fractions of the picture's size
  var FACE_CROP = { x: 0.23, y: 0.18, size: 0.56 };

  // Olive's curls: a halo of big coils around the top and sides of her face
  var CURLS = [];
  (function () {
    var rings = [{ r: 96, n: 11, size: 26 }, { r: 134, n: 13, size: 24 }];
    rings.forEach(function (ring) {
      for (var i = 0; i < ring.n; i++) {
        var a = Math.PI * 0.92 + (i / (ring.n - 1)) * Math.PI * 1.16;
        CURLS.push({ x: CX + Math.cos(a) * ring.r, y: CY + Math.sin(a) * ring.r * 0.92, size: ring.size, spin: i * 1.7 });
      }
    });
  })();

  function storeKey(player) { return player ? STORE_KEY + ':' + player : STORE_KEY; }
  function readBest(player) {
    try { return parseInt(window.localStorage.getItem(storeKey(player)), 10) || 0; } catch (e) { return 0; }
  }
  function saveBest(value, player) {
    try { window.localStorage.setItem(storeKey(player), String(value)); } catch (e) {}
    document.querySelectorAll('tangle-tap-game[data-player="' + (player || '') + '"] [data-best]').forEach(function (el) { el.textContent = value; });
  }

  class TangleTapGame extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('canvas');
      if (!this.canvas || this.ctx) return;
      this.ctx = this.canvas.getContext('2d');
      this.player = this.dataset.player || '';
      this.best = readBest(this.player);
      if (this.player && this.best === 0 && readBest('') > 0) {
        this.best = readBest('');
        saveBest(this.best, this.player);
      }
      this.querySelectorAll('[data-best]').forEach(function (el) { el.textContent = this.best; }, this);
      this.font = getComputedStyle(document.body).fontFamily || 'sans-serif';
      this.state = 'idle';
      this.face = null;
      this.reset();

      this.onFrame = this.onFrame.bind(this);
      this.resize = this.resize.bind(this);
      this.resize();
      window.addEventListener('resize', this.resize);

      var self = this;
      this.canvas.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        if (self.state !== 'running') { self.start(); return; }
        var rect = self.canvas.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * SIZE;
        var y = ((event.clientY - rect.top) / rect.height) * SIZE;
        self.tapAt(x, y, event.pointerType === 'touch' ? 14 : 8);
      });
      this.canvas.addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          if (self.state !== 'running') self.start();
          else self.tapOldest();
        }
      });
      var play = this.querySelector('[data-play]');
      if (play) {
        play.addEventListener('click', function () {
          self.canvas.focus({ preventScroll: true });
          if (self.state !== 'running') self.start();
        });
      }

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) self.loadFace();
            else if (self.state === 'running') self.pause();
          });
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      } else {
        this.loadFace();
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden && self.state === 'running') self.pause();
      });

      this.draw();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.resize);
      if (this.observer) this.observer.disconnect();
      cancelAnimationFrame(this.raf);
    }

    loadFace() {
      if (this.face || !this.dataset.face) return;
      var img = new Image();
      var self = this;
      img.onload = function () { self.face = img; if (self.state !== 'running') self.draw(); };
      img.src = this.dataset.face;
    }

    resize() {
      var ratio = Math.min(window.devicePixelRatio || 1, 2);
      var width = this.canvas.clientWidth || SIZE;
      this.canvas.width = Math.round(width * ratio);
      this.canvas.height = Math.round(width * ratio);
      this.scale = (width * ratio) / SIZE;
      if (this.state !== 'running') this.draw();
    }

    reset() {
      this.score = 0;
      this.lives = LIVES;
      this.combo = 0;
      this.elapsed = 0;
      this.knots = [];
      this.pops = [];
      this.spawnIn = 0.5;
      this.shake = 0;
      this.newBest = false;
      this.time = 0;
    }

    start() {
      if (this.state === 'over' || this.state === 'idle') this.reset();
      this.state = 'running';
      this.loadFace();
      this.last = performance.now();
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(this.onFrame);
    }

    pause() {
      this.state = 'paused';
      cancelAnimationFrame(this.raf);
      this.draw();
    }

    level() {
      var top = parseInt(this.dataset.topSpeed, 10) || 60;
      return Math.min(1, this.score / top);
    }

    spawn() {
      var lvl = this.level();
      if (this.knots.length < 3 + Math.round(lvl * 3)) {
        var spot = null;
        for (var tries = 0; tries < 8 && !spot; tries++) {
          var curl = CURLS[Math.floor(Math.random() * CURLS.length)];
          var free = this.knots.every(function (k) { return Math.hypot(k.x - curl.x, k.y - curl.y) > 40; });
          if (free) spot = curl;
        }
        if (spot) {
          var life = 2.6 - lvl * 1.4;
          this.knots.push({ x: spot.x + (Math.random() - 0.5) * 10, y: spot.y + (Math.random() - 0.5) * 10, age: 0, life: life, spin: Math.random() * 6 });
        }
      }
      this.spawnIn = (1.05 - lvl * 0.6) * (0.75 + Math.random() * 0.5);
    }

    loosen(index) {
      var knot = this.knots[index];
      this.knots.splice(index, 1);
      this.combo += 1;
      var points = 1 + Math.floor(this.combo / 5);
      this.score += points;
      this.pops.push({ x: knot.x, y: knot.y, text: '+' + points, life: 0.6, sparkle: true });
    }

    tapAt(x, y, slack) {
      var hit = -1;
      var bestDist = Infinity;
      for (var i = 0; i < this.knots.length; i++) {
        var k = this.knots[i];
        var d = Math.hypot(k.x - x, k.y - y);
        if (d < this.knotRadius(k) + slack && d < bestDist) { hit = i; bestDist = d; }
      }
      if (hit >= 0) this.loosen(hit);
      else this.combo = 0;
    }

    tapOldest() {
      if (!this.knots.length) { this.combo = 0; return; }
      var oldest = 0;
      for (var i = 1; i < this.knots.length; i++) {
        if (this.knots[i].age / this.knots[i].life > this.knots[oldest].age / this.knots[oldest].life) oldest = i;
      }
      this.loosen(oldest);
    }

    knotRadius(k) {
      return 12 + Math.min(1, k.age / k.life) * 12;
    }

    onFrame(now) {
      if (this.state !== 'running') return;
      var dt = Math.min((now - this.last) / 1000, 0.034);
      this.last = now;
      this.update(dt);
      this.draw();
      if (this.state === 'running') this.raf = requestAnimationFrame(this.onFrame);
    }

    update(dt) {
      this.elapsed += dt;
      this.time += dt;
      this.spawnIn -= dt;
      if (this.spawnIn <= 0) this.spawn();
      if (this.shake > 0) this.shake -= dt;

      for (var i = this.knots.length - 1; i >= 0; i--) {
        var k = this.knots[i];
        k.age += dt;
        k.spin += dt * (2 + (k.age / k.life) * 6);
        if (k.age >= k.life) {
          this.knots.splice(i, 1);
          this.lives -= 1;
          this.combo = 0;
          this.shake = 0.3;
          this.pops.push({ x: k.x, y: k.y, text: '', life: 0.5, sparkle: false });
          if (this.lives <= 0) { this.finish(); return; }
        }
      }
      for (var p = this.pops.length - 1; p >= 0; p--) {
        this.pops[p].life -= dt;
        this.pops[p].y -= 36 * dt;
        if (this.pops[p].life <= 0) this.pops.splice(p, 1);
      }
    }

    finish() {
      this.state = 'over';
      cancelAnimationFrame(this.raf);
      this.knots = [];
      if (this.score > this.best) {
        this.best = this.score;
        this.newBest = true;
        saveBest(this.best, this.player);
      }
      this.draw();
    }

    draw() {
      var c = this.ctx;
      if (!c) return;
      c.setTransform(this.scale, 0, 0, this.scale, 0, 0);
      c.fillStyle = BG;
      c.fillRect(0, 0, SIZE, SIZE);

      c.save();
      if (this.shake > 0) c.translate(Math.sin(this.time * 80) * 4 * (this.shake / 0.3), 0);
      this.drawCharacter();
      for (var i = 0; i < this.knots.length; i++) this.drawKnot(this.knots[i]);
      c.restore();

      c.textAlign = 'center';
      c.textBaseline = 'middle';
      for (var p = 0; p < this.pops.length; p++) {
        var pop = this.pops[p];
        var alpha = Math.max(0, pop.life / 0.6);
        c.globalAlpha = alpha;
        if (pop.sparkle) {
          c.strokeStyle = '#FFFFFF';
          c.lineWidth = 3;
          var spread = (1 - alpha) * 22 + 8;
          for (var s = 0; s < 6; s++) {
            var a = (s / 6) * Math.PI * 2;
            c.beginPath();
            c.moveTo(pop.x + Math.cos(a) * spread * 0.5, pop.y + Math.sin(a) * spread * 0.5);
            c.lineTo(pop.x + Math.cos(a) * spread, pop.y + Math.sin(a) * spread);
            c.stroke();
          }
          c.fillStyle = INK;
          c.font = '700 18px ' + this.font;
          c.fillText(pop.text, pop.x, pop.y - 14);
        } else {
          c.strokeStyle = '#B04A3A';
          c.lineWidth = 3;
          c.beginPath();
          c.arc(pop.x, pop.y, 26 * (1.2 - alpha), 0, Math.PI * 2);
          c.stroke();
        }
      }
      c.globalAlpha = 1;

      // lives as little combs, score and combo
      for (var l = 0; l < LIVES; l++) this.drawComb(22 + l * 30, 26, l < this.lives);
      c.fillStyle = INK;
      c.textAlign = 'right';
      c.textBaseline = 'top';
      c.font = '700 26px ' + this.font;
      c.fillText(String(this.score), SIZE - 16, 10);
      if (this.combo >= 5 && this.state === 'running') {
        c.font = '700 14px ' + this.font;
        c.fillText('x' + (1 + Math.floor(this.combo / 5)), SIZE - 16, 42);
      }

      if (this.state !== 'running') {
        c.fillStyle = 'rgba(255,255,255,0.85)';
        this.roundRect(50, 150, 300, this.state === 'over' ? 112 : 80, 16);
        c.fill();
        c.fillStyle = INK;
        c.textAlign = 'center';
        c.textBaseline = 'middle';
        if (this.state === 'over') {
          c.font = '700 22px ' + this.font;
          c.fillText(this.dataset.finish || '', SIZE / 2, 176);
          c.font = '700 17px ' + this.font;
          c.fillText(this.newBest ? (this.dataset.newBest || '') + ' ' + this.score : String(this.score), SIZE / 2, 206);
          c.font = '400 15px ' + this.font;
          c.fillText(this.dataset.over || '', SIZE / 2, 236);
        } else {
          c.font = '700 20px ' + this.font;
          c.fillText(this.dataset.start || '', SIZE / 2, 190);
        }
      }
    }

    roundRect(x, y, w, h, r) {
      var c = this.ctx;
      c.beginPath();
      c.moveTo(x + r, y);
      c.arcTo(x + w, y, x + w, y + h, r);
      c.arcTo(x + w, y + h, x, y + h, r);
      c.arcTo(x, y + h, x, y, r);
      c.arcTo(x, y, x + w, y, r);
      c.closePath();
    }

    drawCharacter() {
      var c = this.ctx;
      // shoulders
      c.fillStyle = SWEATER;
      c.strokeStyle = INK;
      c.lineWidth = 3;
      c.beginPath();
      c.ellipse(CX, SIZE + 30, 120, 90, 0, Math.PI, 0);
      c.fill();
      c.stroke();
      // curls halo
      for (var i = 0; i < CURLS.length; i++) {
        var curl = CURLS[i];
        c.fillStyle = HAIR;
        c.beginPath();
        c.arc(curl.x, curl.y, curl.size, 0, Math.PI * 2);
        c.fill();
        c.strokeStyle = 'rgba(255,255,255,0.22)';
        c.lineWidth = 2;
        c.beginPath();
        for (var t = 0; t < Math.PI * 4; t += 0.3) {
          var rr = (t / (Math.PI * 4)) * curl.size * 0.8;
          var px = curl.x + Math.cos(t + curl.spin) * rr;
          var py = curl.y + Math.sin(t + curl.spin) * rr;
          if (t === 0) c.moveTo(px, py); else c.lineTo(px, py);
        }
        c.stroke();
      }
      // face
      c.beginPath();
      c.arc(CX, CY, FACE_R, 0, Math.PI * 2);
      c.fillStyle = '#FFFFFF';
      c.fill();
      if (this.face) {
        c.save();
        c.beginPath();
        c.arc(CX, CY, FACE_R - 3, 0, Math.PI * 2);
        c.clip();
        var w = this.face.naturalWidth || 400;
        c.drawImage(this.face, FACE_CROP.x * w, FACE_CROP.y * w, FACE_CROP.size * w, FACE_CROP.size * w, CX - FACE_R, CY - FACE_R, FACE_R * 2, FACE_R * 2);
        c.restore();
      } else {
        c.fillStyle = '#8A5A3C';
        c.beginPath();
        c.arc(CX, CY, FACE_R - 4, 0, Math.PI * 2);
        c.fill();
      }
      c.strokeStyle = INK;
      c.lineWidth = 4;
      c.beginPath();
      c.arc(CX, CY, FACE_R, 0, Math.PI * 2);
      c.stroke();
    }

    drawKnot(k) {
      var c = this.ctx;
      var t = Math.min(1, k.age / k.life);
      var r = this.knotRadius(k);
      c.save();
      c.translate(k.x, k.y);
      // warning glow as it gets close to tangling
      c.fillStyle = t > 0.65 ? 'rgba(176,74,58,' + (0.25 + (t - 0.65) * 1.4) + ')' : 'rgba(255,255,255,0.55)';
      c.beginPath();
      c.arc(0, 0, r + 4, 0, Math.PI * 2);
      c.fill();
      c.rotate(k.spin);
      c.strokeStyle = '#F3E0A1';
      c.lineWidth = 3;
      c.lineCap = 'round';
      c.beginPath();
      for (var a = 0; a <= Math.PI * 6; a += 0.22) {
        var rad = r * (0.4 + 0.6 * Math.abs(Math.sin(a * 1.35)));
        var px = Math.cos(a) * rad;
        var py = Math.sin(a) * rad;
        if (a === 0) c.moveTo(px, py); else c.lineTo(px, py);
      }
      c.stroke();
      c.restore();
    }

    drawComb(x, y, full) {
      var c = this.ctx;
      c.save();
      c.translate(x, y);
      c.globalAlpha = full ? 1 : 0.3;
      c.fillStyle = INK;
      this.roundRect(-11, -8, 22, 6, 2);
      c.fill();
      for (var t = 0; t < 5; t++) c.fillRect(-10 + t * 4.6, -3, 2.2, 10);
      c.restore();
    }
  }

  customElements.define('tangle-tap-game', TangleTapGame);
})();
